<template>
  <div>
    <!-- ============= 顶部背景图 ============= -->
    <div>
      <img src="../../assets/images/about/companybanner.png" style="width: 100%;display: block">
    </div>
    <!-- ============= 公司章程及制度 ============= -->
    <div class="company-stipulate" >
      <div class="company-stipulate-title" style="min-width:1200px;width: 100%;display: inline-block">
        
        <div v-html='cor_governance_html'>
        
        </div>
        
      </div>
    </div>
  </div>
</template>
<style>
    .gszl_table{
        text-align: left;
        margin: auto;
        border-bottom: #ebeef5 solid 0.5px;
        border-left: #ebeef5 solid 0.5px;
        margin-bottom: 20px;
    }
    .gszl_table thead th{
        padding: 10px;
    }
    .gszl_table tbody td{
        border-top: #ebeef5 solid 0.5px;
        border-right: #ebeef5 solid 0.5px;
        padding: 10px;
    }
    .gszl_table a{
        color:black;
    }
</style>
<script>
    export default {
        name: "demo1",
        data () {
            return {
                stipulateList: [
                    {
                        idOne: '01',
                        fileName: '公司章程',
                        idTwo: '02',
                        fileTypeOne: '筹资内部控制制度',
                        idThree: '03',
                        fileTypeTwo: '董事秘书工作规则',
                    },
                    {
                        idOne: '04',
                        fileName: '股东大会议事规则',
                        idTwo: '05',
                        fileTypeOne: '董事会议事规则',
                        idThree: '06',
                        fileTypeTwo: '监事会议事规则',
                    },
                    {
                        idOne: '07',
                        fileName: '董事会专门委员会议事规则',
                        idTwo: '08',
                        fileTypeOne: '独立董事工作制度',
                        idThree: '09',
                        fileTypeTwo: '对外担保管理制度',
                    },
                    {
                        idOne: '10',
                        fileName: '分、子公司管理制度',
                        idTwo: '11',
                        fileTypeOne: '关联交易决策制度',
                        idThree: '12',
                        fileTypeTwo: '募集资金管理办法',
                    },
                    {
                        idOne: '13',
                        fileName: '内部审计管理制度',
                        idTwo: '14',
                        fileTypeOne: '投资者关系管理制度',
                        idThree: '15',
                        fileTypeTwo: '信息披露管理制度',
                    },
                ],
                cor_governance_html:''
            }
        },
        mounted:function(){
            this.getDevelopTools();
        },
        methods: {
            getDevelopTools: function () {
                this.$axios({
                        method:'get',
                        url:'/api/pre/json_go/cor_governance',
                    }).then((response) =>{          //这里使用了ES6的语法
                        this.cor_governance_html = response.data;
                    }).catch((error) =>
                        console.log(error)       //请求失败返回的数据
                    )
            },
        }
    }
</script>

<style>
  .company-framework{height: 749px;background: url("../../assets/images/about/yazhoubeijingtu.png")}
  .company-framework-content{ width: 60%;margin: 0 auto;}
  .company-framework-content-leftTitle{ float: left;background: #4A90E2;padding: 20px;}
  .company-stipulate{width: 60%;margin: 0 auto;}
</style>



// WEBPACK FOOTER //
// src/pages/about/cor_governance.vue